import { createAsyncThunk } from "@reduxjs/toolkit";
import { CoreService } from "./appStore.service";
export class AppActions {
  static fetchAvailableApps = createAsyncThunk(
    "apps/fetchAvailableApps",
    async (payload:any, { rejectWithValue }) => {
      try {
        
        const response = await CoreService.getAvailableApps(payload);
        return response.data;
      } catch (error) {
        if (error instanceof Error) {
          return rejectWithValue(error.message);
        } else {
          return rejectWithValue("An unknown error occurred");
        }
      }
    }
  );

  static fetchInstalledApps = createAsyncThunk(
    "apps/fetchInstalledApps",
    async (_, { rejectWithValue }) => {
      try {
        const response = await CoreService.getInstalledApps();
        return response.data;
      } catch (error) {
        if (error instanceof Error) {
          return rejectWithValue(error.message);
        } else {
          return rejectWithValue("An unknown error occurred");
        }
      }
    }
  );
  
  static fetchAppDetails = createAsyncThunk(
    "apps/fetchAppDetails",
    async (id: string, { rejectWithValue }) => {
      try {
        const response = await CoreService.getAppDetails(id);
        return response.data;
      } catch (error) {
        if (error instanceof Error) {
          return rejectWithValue(error.message);
        } else {
          return rejectWithValue("An unknown error occurred");
        }
      }
    }
  );
  //
  static connectWoocommerceApp = createAsyncThunk(
    "apps/connectWoocommerceApp",
    async (data: any, { rejectWithValue }) => {
      try {
        const response = await CoreService.postConnectWoocommerceApp(data);
        return response.data;
      } catch (error: any) {
        if (!error.response?.data?.status) {
          return rejectWithValue(error?.response?.data);
        } else if (error instanceof Error) {
          return rejectWithValue(error.message);
        } else {
          return rejectWithValue("An unknown error occurred");
        }
      }
    }
  );
  static connectShopifyApp = createAsyncThunk(
    "apps/connectShopifyApp",
    async (data: any, { rejectWithValue }) => {
      try {
        const response = await CoreService.postConnectShopifyApp(data);
        return response.data;
      } catch (error: any) {
        if (!error.response?.data?.status) {
          return rejectWithValue(error?.response?.data);
        } else if (error instanceof Error) {
          return rejectWithValue(error.message);
        } else {
          return rejectWithValue("An unknown error occurred");
        }
      }
    }
  );
  static connectShopifyAppManually = createAsyncThunk(
    "apps/connectShopifyAppManually",
    async (data: any, { rejectWithValue }) => {
      try {
        const response = await CoreService.postConnectShopifyAppManually(data);
        return response.data;
      } catch (error: any) {
        if (!error.response?.data?.status) {
          return rejectWithValue(error?.response?.data);
        } else if (error instanceof Error) {
          return rejectWithValue(error.message);
        } else {
          return rejectWithValue("An unknown error occurred");
        }
      }
    }
  );
  static getFacebookAccountDeatils = createAsyncThunk(
    "apps/facebookConnectedPageList",
    async (data: any, { rejectWithValue }) => {
      try {
        const response = await CoreService.getFacebookAccountDeatils();
        return response;
      } catch (error) {
        if (error instanceof Error) {
          return rejectWithValue(error.message);
        } else {
          return rejectWithValue("An unknown error occurred");
        }
      }
    }
  );

  static getFacebookConnectedPageList = createAsyncThunk(
    "apps/facebookConnectedPageList",
    async (data: any, { rejectWithValue }) => {
      try {
        const response = await CoreService.getFacebookConnectedPageList(data);
        return response;
      } catch (error) {
        if (error instanceof Error) {
          return rejectWithValue(error.message);
        } else {
          return rejectWithValue("An unknown error occurred");
        }
      }
    }
  );

  static getSyncStatus = createAsyncThunk(
    "apps/getSyncStatus",
    async (_, { rejectWithValue }) => {
      try {
        const response = await CoreService.getSyncStatus();
        return response;
      } catch (error) {
        if (error instanceof Error) {
          return rejectWithValue(error.message);
        } else {
          return rejectWithValue("An unknown error occurred");
        }
      }
    }
  );
  static getSyncPastList = createAsyncThunk(
    "apps/getSyncPastList",
    async (data: any, { rejectWithValue }) => {
      try {
        const response = await CoreService.getSyncPastList(data);
        return response;
      } catch (error) {
        if (error instanceof Error) {
          return rejectWithValue(error.message);
        } else {
          return rejectWithValue("An unknown error occurred");
        }
      }
    }
  );
  static refreshFacebookLeadPage = createAsyncThunk(
    "apps/refreshFacebookLeadPage",
    async (data: any, { rejectWithValue }) => {
      try {
        const response = await CoreService.refreshFacebookLeadPage(data);
        return response;
      } catch (error) {
        if (error instanceof Error) {
          return rejectWithValue(error.message);
        } else {
          return rejectWithValue("An unknown error occurred");
        }
      }
    }
  );
  static disconnectFacebook = createAsyncThunk(
    "apps/disconnectFacebook",
    async (data: any, { rejectWithValue }) => {
      try {
        const response = await CoreService.disconnectFacebook(data);
        return response;
      } catch (error) {
        if (error instanceof Error) {
          return rejectWithValue(error.message);
        } else {
          return rejectWithValue("An unknown error occurred");
        }
      }
    }
  );
  static getFacebookConnectedPageFormList = createAsyncThunk(
    "apps/facebookConnectedPageList",
    async (data: any, { rejectWithValue }) => {
      try {
        const response = await CoreService.getFacebookConnectedPageFormList(data);
        return response;
      } catch (error) {
        if (error instanceof Error) {
          return rejectWithValue(error.message);
        } else {
          return rejectWithValue("An unknown error occurred");
        }
      }
    }
  );
  static refreshFacebookLeadForms = createAsyncThunk(
    "apps/refreshFacebookLeadForms",
    async (data: any, { rejectWithValue }) => {
      try {
        const response = await CoreService.refreshFacebookLeadForms(data);
        return response;
      } catch (error) {
        if (error instanceof Error) {
          return rejectWithValue(error.message);
        } else {
          return rejectWithValue("An unknown error occurred");
        }
      }
    }
  );
  static enableDisableFacebookLeadForms = createAsyncThunk(
    "apps/enableDisableFacebookLeadForms",
    async (data: any, { rejectWithValue }) => {
      try {
        const response = await CoreService.enableDisableFacebookLeadForms(data);
        return response;
      } catch (error) {
        if (error instanceof Error) {
          return rejectWithValue(error.message);
        } else {
          return rejectWithValue("An unknown error occurred");
        }
      }
    }
  );
  static enableDisableSingleFacebookLeadForm = createAsyncThunk(
    "apps/enableDisableSingleFacebookLeadForm",
    async (data: any, { rejectWithValue }) => {
      try {
        const response = await CoreService.enableDisableSingleFacebookLeadForm(data);
        return response;
      } catch (error) {
        if (error instanceof Error) {
          return rejectWithValue(error.message);
        } else {
          return rejectWithValue("An unknown error occurred");
        }
      }
    }
  );
  static getFormDetails = createAsyncThunk(
    "apps/getFormDetails",
    async (data: any, { rejectWithValue }) => {
      try {
        const response = await CoreService.getFormDetails(data);
        return response;
      } catch (error) {
        if (error instanceof Error) {
          return rejectWithValue(error.message);
        } else {
          return rejectWithValue("An unknown error occurred");
        }
      }
    }
  );
  static setMappingFields = createAsyncThunk(
    "apps/setMappingFields",
    async (data: any, { rejectWithValue }) => {
      try {
        const response = await CoreService.setMappingFields(data);
        return response;
      } catch (error) {
        console.log(error, "helloError")
        if (error instanceof Error) {
          return rejectWithValue(error.message);
        } else {
          return rejectWithValue("An unknown error occurred");
        }
      }
    }
  );

  static getOpenAiKeyStatus = createAsyncThunk(
    "apps/getOpenAiKeyStatus",
    async (_, { rejectWithValue }) => {
      try {
        const response = await CoreService.getOpenAiKeyStatus();
        return response.data;
      } catch (error) {
        if (error instanceof Error) {
          return rejectWithValue(error.message);
        }
        return rejectWithValue("An unknown error occurred");
      }
    }
  );

  static saveOrUpdateOpenAiKey = createAsyncThunk(
    "apps/saveOrUpdateOpenAiKey",
    async (payload: { key: string; model: string }, { rejectWithValue }) => {
      try {
        const response = await CoreService.saveOrUpdateOpenAiKey(payload.key, payload.model);
        return response.data;
      } catch (error) {
        if (error instanceof Error) {
          return rejectWithValue(error.message);
        }
        return rejectWithValue("An unknown error occurred");
      }
    }
  );

  static deleteOpenAiKey = createAsyncThunk(
    "apps/deleteOpenAiKey",
    async (_, { rejectWithValue }) => {
      try {
        const response = await CoreService.deleteOpenAiKey();
        return response.data;
      } catch (error) {
        if (error instanceof Error) {
          return rejectWithValue(error.message);
        }
        return rejectWithValue("An unknown error occurred");
      }
    }
  );
}

